const MIME_TO_EXTENSION = {
  'application/pdf': '.pdf',
  'image/jpeg': '.jpg',
  'image/png': '.png',
  'image/gif': '.gif',
  'image/tiff': '.tif',
  'image/webp': '.webp',
  'image/bmp': '.bmp',
  'image/svg+xml': '.svg',
  'application/msword': '.doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
  'application/vnd.ms-excel': '.xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
  'text/plain': '.txt',
  'text/csv': '.csv',
  'application/rtf': '.rtf',
  'application/zip': '.zip',
};

export function getExtensionForMime(mimeType) {
  if (!mimeType) return null;
  return MIME_TO_EXTENSION[mimeType.toLowerCase().trim()] || null;
}

export function ensureFilenameExtension(filename, mimeType) {
  if (!filename || !mimeType) return filename || 'download';
  const ext = getExtensionForMime(mimeType);
  if (!ext) return filename;
  const lastDot = filename.lastIndexOf('.');
  if (lastDot > 0 && lastDot < filename.length - 1) return filename;
  return `${filename}${ext}`;
}
